/**
 * Default price lists the app prices against.
 *
 * Centralized so POS, sales invoices, warehouse item setup and healthcare
 * settings all read and write the SAME lists. A drift here is silent and
 * costly: a rate saved on one list is invisible to a lookup on another (this
 * is exactly how boarding stays ended up unpriced). Change the literal here
 * and every surface follows.
 */
export const DEFAULT_SELLING_PRICE_LIST = "Standard Selling";
export const DEFAULT_BUYING_PRICE_LIST = "Standard Buying";
